import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export default styled(NavLink)`
    text-decoration: none;
    flex-shrink: 0;
    -webkit-appearance: unset !important;
`;
